import React from 'react';
import ScrollAnimation from "react-animate-on-scroll";

const TimelineData = [
    {
        id: "1",
        title: " Diseño web",
        description: "Desarrollamos y diseñamos tu paginas web o landings pages  para publicitar tu idea. ",
    },
    {
        id: "2",
        title: "Campañas de Google AdWords ",
        description: "Conectamos con tus clientes con campañas dirigidas a quien necesite tu producto o servicio.",
    },
    {
        id: "3",
        title: "Posicionamiento SEO",
        description: "Optimizamos contenido para que los buscadores como Google te puedan encontrar.",
    },
    {
        id: "4",
        title: "iCampaña de Branding!",
        description: "Creamos tu campaña para acercarte al tus clientes, que te conozcan y que tu los conozcas.",
    },
]

const TimelineApp = ({classVar}) => {
    return (
        <div className="timeline-style-two bg-color-blackest">
            <div className="row row--0">
                {/* Start Single Progress */}
                {TimelineData.map((data , index) =>(
                    <div className={`col-lg-3 col-md-3 rn-timeline-single ${classVar}`} key={index}>
                        <div className="rn-timeline">
                            
                                <h6 className="title">{data.title}</h6>
                            <div className="progress-line">
                                <div className="line-inner"></div>
                            </div>
                            <div className="progress-dot">
                                <div className="dot-level">
                                    <div className="dot-inner"></div>
                                </div>
                            </div>
                          
                                <p className="description">{data.description}</p>
                      
                        </div>
                    </div>
                ))}
                {/* End Single Progress */}
            </div>
        </div>
    )
}
export default TimelineApp;
